const Loading = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600" />
        <span className="text-sm font-medium text-gray-500">로딩 중...</span>
      </div>
    </div>
  )
}

export default Loading
